import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import ContactPage from './pages/ContactPage';
import PoetsPage from './pages/PoetsPage';
import MusicPage from './pages/MusicPage';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="min-h-screen flex flex-col bg-stone-50 dark:bg-navy-950 font-sans text-stone-800 dark:text-stone-200 transition-colors duration-300">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/konzepte" element={<Navigate to="/musik" replace />} />
              <Route path="/textdichter" element={<PoetsPage />} />
              <Route path="/musik" element={<MusicPage />} />
              <Route path="/lied/:id" element={<MusicPage />} />
              <Route path="/kontakt" element={<ContactPage />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/dsgvo" element={<Datenschutz />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
